import 'css-chunk:src/app/components/InstagramMeta/MetaItems/pages/Layout.scss';export default {
  "noMargin": "_noMargin_6egsk_1",
  "regular": "_regular_6egsk_5"
};